import { render } from "./forgotpasswordpage.vue?vue&type=template&id=6edebe87&scoped=true"
import script from "./forgotpasswordpage.vue?vue&type=script&lang=js"
export * from "./forgotpasswordpage.vue?vue&type=script&lang=js"

import "./forgotpasswordpage.vue?vue&type=style&index=0&id=6edebe87&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6edebe87"]])

export default __exports__